import Vue from 'vue'
import Vuex, {mapState} from 'vuex'
import user from './modules/user'
import dicts from './modules/dicts'
import createPersistedState from 'vuex-persistedstate'
import * as Cookie from 'js-cookie'
import {COOKIE_AUTH_TOKEN, DEV_AUTH_TOKEN} from '@/config'

//import localStore from 'store';

export const STORAGE_KEY = 'vuex';


Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    dicts
  },
  plugins: [createPersistedState({
    key: STORAGE_KEY,
    paths: ['dicts',],
    getState: (key) => {
      let storageStateJson = window.sessionStorage.getItem(key);
      let storageState = storageStateJson && JSON.parse(storageStateJson) || null;

      let state = storageState || {};

      let authToken = Cookie.get(COOKIE_AUTH_TOKEN);
      if (DEV_AUTH_TOKEN) authToken = DEV_AUTH_TOKEN;

      state.user = {...state.user, authToken};

      return state;
    },
    setState: (key, state) => {
      let nextDicts = {};
      let existsAnyDict = false;
      if (state && state.dicts) {
        for (let key in state.dicts) {
          if (!key || key.indexOf('loading') >= 0) continue;
          let dict = state.dicts[key];
          if (!dict) continue;

          nextDicts[key] = dict;
          existsAnyDict = true;
        }
      }

      if (existsAnyDict) {
        let storageStateJson = window.sessionStorage.getItem(key);
        let storageState = storageStateJson && JSON.parse(storageStateJson) || null;
        let storageDicts = storageState && storageState.dicts || {};

        let nextState = {dicts: {...storageDicts, ...nextDicts}};
        let nextStateJson = JSON.stringify(nextState);
        if (storageStateJson !== nextStateJson) window.sessionStorage.setItem(key, JSON.stringify(nextState))
      }
    },
  })],
});

store.watch((state) => state.user.authToken, async (value, oldValue) => {
  store.dispatch('user/update', {authToken: value});
}, { immediate: true });


export const mapDicts = (args) => {
  if (args && typeof args == 'object') {
    let fields;

    if (Array.isArray(args)) fields = args;
    else fields = Object.values(args);

    // поля типа "loading..." не являются справочничами, методы для их загрузки вызывать не нужно
    fields = fields.filter(a => a && a.indexOf('loading') < 0);

    // вызываем методы для ленивой загрузки словарей
    fields.forEach(arg => store.dispatch('dicts/lazily' + arg[0].toUpperCase() + arg.slice(1)));
  }

  return mapState('dicts', args);
};

// быстрый доступ к токену авторизации
export function authToken() {
  if (!store || !store.state || !store.state.user) return null;
  return store.state.user.authToken;
}

export default store;
